











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import {BOOKING_HOURS, getStoreSettings} from '@/common';

@Component({
    components: {},
})
export default class HourPicker extends Vue {
    public sections = [];

    @Prop({default: () => []})
    public disallowedHours!: number[];

    @Prop({default: 6})
    public value!: number;

    @Watch('hourPicked')
    public onHourPickedChanged(value: number, oldValue: number) {
        this.$emit('input', value);
    }
    public mounted(){
        this.getSections();
    }
    public async getSections(){
        this.sections = BOOKING_HOURS.getHours(await getStoreSettings(this.$FeathersVuex.Settings))
    }
    public convertFrom24(h: number, addHour: false): string {
        let dt = DateTime.fromFormat(h.toString(), 'H');
        if (addHour) {
            dt = dt.plus({hours: 1});
        }
        return dt.toFormat('h a');
    }
}
